module.exports = __webpack_public_path__ + "media/images/logo_sumai_white-556cfa582eba4fbaf099c0869dd55d3b.png";